<template>
  <i-modal :title="title"
           width="595"
           class="cloud-storage-file-move-or-save"
           :value="isShowed"
           @on-visible-change="changeHandler">
    <i-tree :data="treeData" ref="tree"></i-tree>
    <div slot="footer">
      <div class="l-flex-end l-flex-grow-1">
        <i-button type="text" size="large" @click="cancelModel">取消</i-button>
        <i-button type="primary" size="large" @click="confirmMove" v-if="type === 'move'">确定</i-button>
        <i-button type="primary" size="large" @click="confirmSave" v-else>确定</i-button>
      </div>
    </div>
  </i-modal>
</template>

<script>

import { Modal, Tree } from 'iview'
import * as MSG from 'assets/data/message.js'
import api from 'modules/member/api/index.js'
import { formatTreeData } from '@/common/js/utils'

export default {
  name: 'FileMoveOrSave',
  data () {
    return {
      apiProcessing: false,
      treeData: []
    }
  },
  watch: {
    async isShowed (newVal) {
      if (newVal) {
        this.init()
      }
    }
  },
  computed: {
  },
  props: {
    isShowed: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'move'
    },
    title: {
      type: String,
      default: '移动到'
    },
    fileInfo: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  model: {
    prop: 'isShowed',
    event: 'change-show'
  },
  methods: {
    changeHandler (isShowed) {
      this.$emit('change-show', isShowed)
    },
    cancelModel () {
      this.$emit('change-show', false) // 关闭弹窗
    },
    async init (cb) {
      // 此页面没有分页
      const res = await api.fetchFolderList()
      this.treeData = formatTreeData(res)
    },
    async confirmMove () {
      if (this.apiProcessing) {
        this.$store.commit('ADD_MESSAGE', { msg: MSG.GLOBAL_PROCESSING, type: 'error' })
        return false
      }
      // 获取选中的文件夹
      let selFolder = {}
      const selFolderArr = this.$refs.tree.getSelectedNodes() || []
      // 未选择文件夹
      if (selFolderArr.length === 0) {
        this.$store.commit('ADD_MESSAGE', {
          type: 'error',
          msg: '请选择文件夹'
        })
        return
      } else {
        selFolder = selFolderArr[0]
      }
      this.apiProcessing = true
      // 移动我的文件
      const res = await api.moveFile({
        source_file_id: this.fileInfo && this.fileInfo.id ? this.fileInfo.id : '',
        target_folder_id: selFolder.id
      })
      if (res.code === 200) {
        this.$store.commit('ADD_MESSAGE', {
          type: 'success',
          msg: '已移动到指定文件夹'
        })
        setTimeout(() => {
          this.$emit('confirm', true)
          this.$emit('change-show', false)
        }, 2000)
      } else {
        this.$store.commit('ADD_MESSAGE', {
          type: 'warn',
          msg: '出错了，请重试或取消'
        })
      }
      this.apiProcessing = false
    },
    async confirmSave () {
      if (this.apiProcessing) {
        this.$store.commit('ADD_MESSAGE', { msg: MSG.GLOBAL_PROCESSING, type: 'error' })
        return false
      }
      // 获取选中的文件夹
      let selFolder = {}
      const selFolderArr = this.$refs.tree.getSelectedNodes() || []
      // 未选择文件夹
      if (selFolderArr.length === 0) {
        this.$store.commit('ADD_MESSAGE', {
          type: 'error',
          msg: '请选择文件夹'
        })
        return
      } else {
        selFolder = selFolderArr[0]
      }
      this.apiProcessing = true
      // 保存文件
      const res = await api.saveFile({
        cloud_file_code: this.fileInfo && this.fileInfo.code ? this.fileInfo.code : '',
        parent_folder_id: selFolder.id,
        share_log_id: this.fileInfo && this.fileInfo.id ? this.fileInfo.id : ''
      })
      if (res.code === 200) {
        this.$store.commit('ADD_MESSAGE', {
          type: 'success',
          msg: '文件保存成功！'
        })
        setTimeout(() => {
          this.$emit('confirm', {folderId: selFolder.id})
          this.$emit('change-show', false)
        }, 2000)
      } else {
        this.$store.commit('ADD_MESSAGE', {
          type: 'warn',
          msg: '出错了，请重试或取消'
        })
      }
      this.apiProcessing = false
    }
  },
  components: {
    'i-modal': Modal,
    'i-tree': Tree
  }
}
</script>

<style lang="stylus">
.cloud-storage-file-move-or-save
  .ivu-modal-header
    padding-bottom: 18px!important
  .ivu-tree
    .ivu-tree-arrow.ivu-tree-arrow-open
      font-size: 16px
    & > ul > li
      margin-top: 0!important
    .ivu-tree-children
    .ivu-tree-title
      font-size: 18px
    .ivu-tree-children .ivu-tree-title
      font-size: 16px
      position: relative
      margin-left: 28px
      &::before
        content: " "
        height: 18px
        width: 18px
        background: red
        position: absolute
        left: -22px
        top: 3px
        background: url('../../assets/cloudstorage/icon-folder.png') center 0 no-repeat
        background-size: 18px 18px
    .ivu-tree-title-selected, .ivu-tree-title-selected:hover, .ivu-tree-title:hover
      background-color: #ffffff
      color: #F7B52C
      font-weight : 500
</style>



// WEBPACK FOOTER //
// src/components/cloudstorage/FileMoveOrSave.vue